import { acceptHMRUpdate, defineStore } from 'pinia';
import { type ValidationStoreState } from '@/stores/schemas';

export const useValidationStore = defineStore('validation', {
	state: (): ValidationStoreState => ({
		errors: {},
	}),

	getters: {
		hasErrors(state) {
			return Object.keys(state.errors).length > 0;
		},

		errorsExcept(state) {
			return (rules: string[]) =>
				Object.fromEntries(Object.entries(state.errors).filter(([rule]) => !rules.includes(rule)));
		},

		errorsExceptFlat() {
			return (rules: string[]) => Object.values(this.errorsExcept(rules)).flatMap((errors) => errors);
		},

		messages(state): string[] {
			return Object.values(state.errors).flat();
		},
	},

	actions: {
		clearErrors() {
			this.errors = {};
		},

		setErrors(errors: Record<string, string[]> = {}) {
			this.errors = errors;
		},
	},
});

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useValidationStore, import.meta.hot));
}
